<div class="flex flex-col gap-6">
  <div class="flex justify-start">
    <div class="card p-4 inline-flex flex-col gap-4 filters">
      <div class="flex items-center gap-4 h-14 inputs">
        <cac-field class="w-44 h-full" [control]="filters.controls.from" label="From" controlType="date"></cac-field>
        <cac-field class="w-44 h-full" [control]="filters.controls.to" label="To" controlType="date"></cac-field>
        <cac-field class="w-56 h-full" [control]="filters.controls.vendors" label="Vendors" controlType="select" [multiple]="true"
          [items]="getVendorItems" />
        <div class="flex items-center gap-2">
          <cac-button size="sm" [appearance]="isRangeSelected(7) ? 'filled' : 'text'" (onClick)="setQuickRange(7)">
            7D
          </cac-button>
          <cac-button size="sm" [appearance]="isRangeSelected(30) ? 'filled' : 'text'" (onClick)="setQuickRange(30)">
            30D
          </cac-button>
          <cac-button size="sm" [appearance]="isRangeSelected(90) ? 'filled' : 'text'" (onClick)="setQuickRange(90)">
            90D
          </cac-button>
          <cac-button size="sm" [appearance]="isThisYearSelected() ? 'filled' : 'text'" (onClick)="setThisYearRange()">
            This Year
          </cac-button>
        </div>
      </div>
      @if (dateError()) {
      <div class="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">
        {{ dateError() }}
      </div>
      }
    </div>
  </div>

  @if (isLoading()) {
  <div class="flex justify-center p-4"><mat-spinner diameter="32"></mat-spinner></div>
  }
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <div class="stat-card gradient-1">
      <div class="text-sm text-gray-500">Total Sales Amount</div>
      <div class="text-3xl font-semibold">{{ totalSalesAmount() | number:'1.2-3' }} KWD</div>
    </div>
    <div class="stat-card gradient-2">
      <div class="text-sm text-gray-500">Total Sales Count</div>
      <div class="text-3xl font-semibold">{{ totalSalesCount() }}</div>
    </div>
    <div class="stat-card gradient-3">
      <div class="text-sm text-gray-500">Best Sellers</div>
      <div class="text-lg font-medium">{{ bestSellers().length }} products</div>
    </div>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div class="card p-4">
      <div class="font-medium mb-4">Orders Count by Date</div>
      <div class="chart" id="ordersCountChart"></div>
      @if (!ordersCountByDate().length) {
      <div class="chart-empty">No data</div>
      }
    </div>
    <div class="card p-4">
      <div class="font-medium mb-4">Orders Amount by Date</div>
      <div class="chart" id="ordersAmountChart"></div>
      @if (!ordersAmountByDate().length) {
      <div class="chart-empty">No data</div>
      }
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div class="card p-4">
      <div class="font-medium mb-4">Top Customers</div>
      <div class="overflow-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="text-left text-gray-500">
              <th class="py-2 pr-4">ID</th>
              <th class="py-2 pr-4">Name</th>
              <th class="py-2 pr-4 text-right">Orders</th>
              <th class="py-2 text-right">Total Amount</th>
            </tr>
          </thead>
          <tbody>
            @for (c of topCustomers(); track c.userId) {
            <tr class="border-t border-outline">
              <td class="py-2 pr-4">{{ c.userId }}</td>
              <td class="py-2 pr-4">{{ c.fullName }}</td>
              <td class="py-2 pr-4 text-right">{{ c.ordersCount }}</td>
              <td class="py-2 text-right">{{ c.ordersTotalAmount | number:'1.2-3' }} KWD</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="card p-4">
      <div class="font-medium mb-2">Top Search Terms</div>
      <div class="chart" id="topSearchTermsChart"></div>
      @if (!topSearchTerms().length) {
      <div class="chart-empty">No data</div>
      }
    </div>
  </div>

  <div class="card p-6">
    <div class="font-medium mb-4">Best Sellers</div>
    <div class="space-y-3 max-h-96 overflow-auto pr-2">
      @for (b of bestSellers(); track b.productId) {
      <div class="flex items-center justify-between text-sm">
        <div class="flex items-center gap-3">
          @if (b.url) {
          <img [src]="b.url" class="w-10 h-10 object-cover rounded" alt="" />
          } @else {
          <div class="w-10 h-10 bg-gray-100 border rounded flex items-center justify-center">
            <cac-icon icon="box" size="1rem"></cac-icon>
          </div>
          }
          <div>
            <div class="font-medium">{{ b.productNameEn }}</div>
            <div class="text-gray-500">{{ b.price | number:'1.2-3' }} KWD</div>
          </div>
        </div>
        <div class="font-medium">{{ b.purchasedUnits }} sold</div>
      </div>
      }
    </div>
  </div>
</div>